/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductDto } from '../../models/backend-product-dto';
import { BackendProductRequestDto } from '../../models/backend-product-request-dto';

export interface OpexesProductsUpdate$FormData$Params {
  id: number;
  body: BackendProductRequestDto;
}

export function opexesProductsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: OpexesProductsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductDto>> {
  const rb = new RequestBuilder(rootUrl, opexesProductsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductDto>;
    }),
  );
}

opexesProductsUpdate$FormData.PATH = '/api/opexes/products/{id}/';
